import { render } from "./mess.vue?vue&type=template&id=5e36635b&scoped=true"
import script from "./mess.vue?vue&type=script&lang=js"
export * from "./mess.vue?vue&type=script&lang=js"

import "./mess.vue?vue&type=style&index=0&id=5e36635b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@5.110.3_clean-css@5.3.3_c_fd8bdb85bb9a93cd57e0f6a421dc3a81/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e36635b"]])

export default __exports__